export default "__VITE_ASSET__ef2e28dd__"